import styled from 'styled-components'

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  width: 100%;
  align-items: center;
`
